import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Css/Login.css';
import test from "../Image/test.jpg";
import kit_mark from "../Image/kit_mark.png";
import axios from 'axios';
import config from "../ip.json";

const Login = () => {
    const [id, setId] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault(); // Prevent default form submission behavior

        try {
            const form = document.getElementById("loginForm");
            const formData = new FormData(form);

            const response = await axios.post(config.url + "/login", formData, {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
                withCredentials: true, // If cookies are needed for the session
            });

            console.log(response.headers); // Check response headers for debugging
            let jwtToken = response.headers.get("Authorization");

            if(jwtToken!==null){
                // 세션 스토리지에 Authorization 를 set함
                sessionStorage.setItem("Authorization", jwtToken);
                navigate('/Payment');


            }



            // Navigate to /Payment page only after a successful login
        } catch (error) {
            console.error("Error during login:", error);
            setError("로그인 실패! 사용자 이름과 비밀번호를 확인해 주세요.");
        }
    };

    return (
        <div className="login-container">
            <div className={'mark-box'}>
                <img className="kit_mark" src={kit_mark} alt="See more" />
            </div>

            <form onSubmit={handleLogin} className="login-form" id="loginForm">
                <h2>로그인</h2>

                {error && <div className="error-message">{error}</div>} {/* Display error message */}

                <div className="input-group">
                    <input
                        type="text"
                        id="id"
                        name="username"
                        value={id}
                        onChange={(e) => setId(e.target.value)}
                        placeholder="ID"
                        required
                    />
                </div>
                <div className="input-group">
                    <input
                        type="password"
                        id="password"
                        name="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="PASSWORD"
                        required
                    />
                </div>

                <button type="submit" className="login-btn">Login</button>
            </form>

            <img className="test_1" src={test} alt="See more" />
        </div>
    );
};

export default Login;
